import { useEffect } from "../../../__compat__/react/main.entry.mjs.mjs";
export const useFocusTrap = ({ open, ref, triggerRef, }) => {
    useEffect(() => {
        if (!open || !ref.current) {
            return;
        }
        const focusableElements = ref.current.querySelectorAll(' button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];
        const handleKeyDown = (event) => {
            if (event.key === 'Tab') {
                if (event.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus();
                        event.preventDefault();
                    }
                }
                else {
                    if (document.activeElement === lastFocusableElement) {
                        firstFocusableElement.focus();
                        event.preventDefault();
                    }
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        const triggerEl = triggerRef.current;
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            if (triggerRef && triggerEl) {
                triggerEl.focus();
            }
        };
    }, [open, ref, triggerRef]);
    return ref;
};
//# sourceMappingURL=use-focus-trap.mjs.mjs.map